import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserProfilePage } from "./UserProfilePage";

export const PersonalRoutes = () => {

    return (
        <Routes>
            <Route path="/profile" element={<UserProfilePage />} />
        </Routes>
    );
}